
import { z } from 'zod';

// Helper function to normalize strings
const normalizeString = (value: string | null) => {
  if (!value) return null;
  return value.trim();
};

// Form schema using zod
export const harvestFormSchema = z.object({
  farm_id: z.string().uuid(),
  status: z.enum(['planned', 'in_progress', 'completed', 'cancelled']),
  expected_date: z.string().nullable(),
  starting_date: z.string().nullable().optional(),
  ending_date: z.string().nullable().optional(),
  actual_date: z.string().nullable().optional(),
  expected_quantity: z.coerce.number().nullable(),
  actual_quantity: z.coerce.number().nullable().optional(),
  quality_grade: z.string().nullable()
    .transform(normalizeString)
    .optional(),
  notes: z.string().nullable()
    .transform(normalizeString)
    .optional(),
  product_name: z.string().nullable().optional()
})
// Transform to handle alternative date field names
.transform((data) => {
  const result = { ...data };
  
  // Use starting_date as expected_date if provided and expected_date is not
  if (data.starting_date && !data.expected_date) {
    result.expected_date = data.starting_date;
  }
  
  // Clean up the alternative fields before submission
  delete result.starting_date;
  delete result.ending_date;
  
  return result;
});

export type HarvestFormValues = z.infer<typeof harvestFormSchema>;
